import * as React from 'react';
import { useMemo } from 'react';
import cn from 'classnames';

import { GdsAggregationServiceGroup, GdsAggregationServiceMisc } from '../../../../../types';
import { getMiscServiceGroups } from '@shared/lib/gdsService';
import CheckoutCardExtrasProvider from '../../../../../../CardExtra/CheckoutCardExtrasProvider';
import CardExtra from '../../../../../../CardExtra';
import { useTheme } from '../../../../../../theme';

interface Props {
	service?: GdsAggregationServiceGroup;
	hideCard?: boolean;
	segmentId?: string;
}

const Misc: React.FC<Props> = ({ service, hideCard, segmentId }) => {
	const theme = useTheme('Checkout').ServicesAggregationPage;
	const servicesGroups = useMemo(() => {
		return getMiscServiceGroups(service.services as GdsAggregationServiceMisc[]);
	}, [service.services]);

	return (
		<CheckoutCardExtrasProvider>
			{servicesGroups.map(group => (
				<div key={group.key} className={cn({ [theme.hideServiceCard]: hideCard })}>
					<CardExtra {...group} type="misc" variant="aggregator" segmentId={segmentId} />
				</div>
			))}
		</CheckoutCardExtrasProvider>
	);
};

export default Misc;
